import foxDesk from '../../../media/experience/fox/desk.jpeg';
import foxLot from '../../../media/experience/fox/lot.jpeg';
import foxSports from '../../../media/experience/fox/fox-sports.jpeg';
import familyGuy from '../../../media/experience/fox/family-guy.jpeg';
import starWars from '../../../media/experience/fox/star-wars.jpeg';
import sevenYearItch from '../../../media/experience/fox/seven-year-itch.jpeg';
import palantirTraining from '../../../media/experience/fox/palantir-training.jpeg';
import aiAtFoxPortal from '../../../media/experience/fox/ai-at-fox-portal.png';
import foxDevWorkspace from '../../../media/experience/fox/fox-dev-workspace.png';

const foxData = {
  company: "FOX",
  slug: "fox",
  poster: starWars,
  location: "Los Angeles, CA",
  heroImage: foxLot,

  roles: [
    {
      title: "Software Engineer, AI/ML",
      start: "August 2026",
      end: "Present",
      location: "New York, NY",
      summary: "In August I moved into software engineering across FOX Corporation, with most of the work in ad sales. I build time-series forecasts with gradient-boosted models, including models I train for FOX, and I run Fundamental's [[Nexus::https://fundamental.tech/nexus]] large tabular model as a benchmark and alongside those models. I built a local non-linear editor in Electron that FOX News now uses in the field. I also contributed to [[AdStudio's::FOX release::https://www.foxcorporation.com/news/corp-press-releases/2026/fox-advertising-to-launch-industrys-first-end-to-end-agentic-advertising-platform-powered-by-fox-adstudio/::Adweek::https://www.adweek.com/convergent-tv/fox-expands-agentic-push-with-eyes-set-on-tv-upfront-future/]] agent-to-agent advertising platform, the system FOX announced in June 2026 for planning, buying, and activation across linear and digital. FOX's agents can organize, negotiate, reschedule, and sell spot time to advertisers programmatically, and a buyer can transact through an LLM agent or the website. That layer sits on the [[Databricks estate::https://www.databricks.com/company/newsroom/press-releases/fox-corporation-selects-databricks-strategic-partner-next]] where FOX's data already lives. I use it daily: Lakebase, Genie Code, Unity Gateway, and Genie Ontology.",
    },
    {
      title: "AI Solutions Engineer",
      start: "January 2026",
      end: "June 2026",
      location: "Los Angeles, CA",
      summary: "At FOX, I work on the AI Solutions team, which grew out of the AI Enablement group I joined when I started. I am forward-deployed across nine business units. A lot of my time goes to Palantir Foundry: pulling data from scattered sources into one governed source of truth, building ingestion and transformation pipelines, defining object types and links in the ontology, and wiring normalized datasets into operational apps. I am Palantir Foundry and AIP certified through Ontologize and have worked with data connections, Pipeline Builder, Code Repositories, Ontology Manager, and Workshop. I also ship production AI systems, usually with a different stack per project: Bedrock chat with server-sent event streaming, Next.js and React frontends with FastAPI backends, internal GPT platforms with OAuth 2.0, MCP-based tracking, and RAG pipelines that combine vector search with Neo4j graph data and custom graph algorithms for grounding across tens of thousands of enterprise documents. Those builds usually tie into CMS content, stream responses in real time, and run more than one model. I deploy on AWS with CDK and Terraform (ECS Fargate, DynamoDB, S3, CloudFront, Lambda) in TypeScript and Python. I wrote the technical plan and migration approach for moving several apps off Salesforce onto Docker containers on ECS Fargate via a custom AWS stack, and led the contractor team that executed it. I also run AI enablement at FOX: Cursor and Claude training, serving as FOX's Cursor liaison, and a Cursor Marketplace plugin that sets agent workflows, environment defaults, and guardrails as the org's AI tooling grows.",
    },
  ],

  techStack: [
    "Palantir Foundry & AIP",
    "Pipeline Builder",
    "Ontology Manager",
    "Workshop",
    "PySpark",
    "Next.js",
    "React",
    "TypeScript",
    "Python",
    "Databricks Lakebase",
    "Genie Code",
    "Unity Gateway",
    "Genie Ontology",
    "Fundamental Nexus",
    "Gradient boosting",
    "Time-series forecasting",
    "Electron",
    "FastAPI",
    "Node.js",
    "Amazon Bedrock",
    "RAG",
    "Neo4j",
    "Vector search & embeddings",
    "Graph algorithms",
    "AWS CDK",
    "Terraform",
    "ECS Fargate",
    "DynamoDB",
    "S3 + CloudFront",
    "OAuth 2.0 + JWT",
    "Docker",
    "MCP Servers",
    "Cursor (Liaison & Marketplace Plugin)",
    "Server-Sent Events (SSE)",
    "Tailwind CSS"
  ],

  gallery: [
    { type: 'image', src: foxDesk, alt: 'At my desk at FOX Studios in Los Angeles' },
    { type: 'image', src: palantirTraining, alt: 'Palantir Foundry and AIP certification training with Ontologize' },
    { type: 'image', src: aiAtFoxPortal, alt: 'AI @ FOX internal portal on the studio monitor: employee AI hub with OpenAI, Anthropic, and Gemini resources' },
    { type: 'image', src: foxDevWorkspace, alt: 'FOX engineering workspace: AI Solutions development on fox-repo, including graph and vector store work' },
    { type: 'image', src: foxSports, alt: 'FOX Sports studio headquarters' },
    { type: 'image', src: familyGuy, alt: 'Family Guy mural on the FOX studio lot' },
    { type: 'image', src: starWars, alt: 'Star Wars mural on the FOX studio lot' },
    { type: 'image', src: sevenYearItch, alt: 'The Seven Year Itch mural on the FOX studio lot' },
    { type: 'image', src: foxLot, alt: 'On the FOX studio lot in Los Angeles' }
  ],

  links: {
    company: "https://www.foxcorporation.com/",
    linkedin: "https://www.linkedin.com/company/fox-corporation/",
  }
};

export default foxData;
